module.exports = __webpack_public_path__ + "img/Intelligential-logo-texto-blanco.2c722d2e.png";